import React, { useState, useEffect } from 'react';
import api from '../services/api';

function UserList() {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ firstName: '', lastName: '', teacher: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await api.get('/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const addUser = async (e) => {
    e.preventDefault();
    try {
      await api.post('/users', newUser);
      setNewUser({ firstName: '', lastName: '', teacher: '' });
      fetchUsers();
    } catch (error) {
      console.error('Error adding user:', error);
    }
  };

  const deleteUser = async (id) => {
    try {
      await api.delete(`/users/${id}`);
      fetchUsers();
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  if (loading) return <div>Loading users...</div>;

  return (
    <div>
      <h2>Users Management</h2>
      
      <form onSubmit={addUser} style={{marginBottom: '20px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '4px'}}>
        <h3>Add New User</h3>
        <div style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
          <input
            type="text"
            placeholder="First Name"
            value={newUser.firstName}
            onChange={(e) => setNewUser({...newUser, firstName: e.target.value})}
            style={{flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            required
          />
          <input
            type="text"
            placeholder="Last Name"
            value={newUser.lastName}
            onChange={(e) => setNewUser({...newUser, lastName: e.target.value})}
            style={{flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            required
          />
          <input
            type="text"
            placeholder="Teacher"
            value={newUser.teacher}
            onChange={(e) => setNewUser({...newUser, teacher: e.target.value})}
            style={{flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '4px'}}
            required
          />
        </div>
        <button type="submit" style={{
          padding: '8px 16px',
          backgroundColor: '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>
          Add User
        </button>
      </form>

      <div>
        <h3>User List ({users.length} users)</h3>
        {users.length === 0 ? (
          <p>No users registered.</p>
        ) : (
          <table style={{width: '100%', borderCollapse: 'collapse'}}>
            <thead>
              <tr style={{backgroundColor: '#f8f9fa'}}>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>First Name</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Last Name</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Teacher</th>
                <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>{user.first_name}</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>{user.last_name}</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>{user.teacher}</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>
                    <button
                      onClick={() => deleteUser(user.id)}
                      style={{
                        padding: '4px 8px',
                        backgroundColor: '#dc3545',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default UserList;
